import React from 'react';
// import PropTypes from 'prop-types';
import Menu from '../Menu';
import HeaderStyled from './Header-Styles';
import Logo from '../ui/SVGs/Logo';
import useGlobal from '../../store';

export default function Header(props) {
    const { isHomepageHeader, windowSize } = props;
    const history = window.location.pathname;
    const [globalState, globalActions] = useGlobal();
    const defaultSection = { logo: {}, menu: [] };
    const { header: { logo: logo, menu: menu } = defaultSection } = globalState;
    const transparentLogo = logo?.transparent_logo?.file;
    const coloredLogo = logo?.colored_logo?.file;

    return (
        <HeaderStyled
            className={`header ${
                isHomepageHeader ? 'header--transparent' : 'header--solid'
            }`}
            history={history}
        >
            <div className="container">
                <section className="header--left">
                    {windowSize && windowSize.width > 767 ? (
                        <Logo
                            className="header__logo"
                            isLogoWhite={isHomepageHeader}
                            whiteLogoGreeanAmerica={transparentLogo}
                            logoGreenAmerica={coloredLogo}
                        />
                    ) : (
                        <Logo
                            width="146"
                            height="31"
                            className="header__logo--mobile "
                            logoGreenAmerica={coloredLogo}
                        />
                    )}
                </section>
                <section className="header--right">
                    <Menu
                        className={
                            isHomepageHeader
                                ? 'menu--transparent'
                                : 'menu--solid'
                        }
                        getWindowSize={windowSize}
                        menuItems={menu}
                    />
                </section>
            </div>
        </HeaderStyled>
    );
}
